import { useState, FormEvent } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import Navbar from "../../../components/layout/Navbar";
import { Button } from "../../../components/Button";
import { usePasswordResetConfirmMutation } from "../../../services/authApi";
import { toast } from "sonner";

const ChangePassword = () => {
  const { uid, token } = useParams();
  const navigate = useNavigate();
  const [passwordResetConfirm, { isLoading }] =
    usePasswordResetConfirmMutation();

  const [formData, setFormData] = useState({
    newPassword1: "",
    newPassword2: "",
  });
  const [error, setError] = useState("");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError("");

    // Validate passwords match
    if (formData.newPassword1 !== formData.newPassword2) {
      setError("Passwords don't match");
      return;
    }

    // Validate password is not empty
    if (!formData.newPassword1) {
      setError("Password cannot be empty");
      return;
    }

    try {
      if (uid && token) {
        await passwordResetConfirm({
          uid,
          token,
          new_password1: formData.newPassword1,
          new_password2: formData.newPassword2,
        }).unwrap();

        toast.success("Password Reset Successfully");

        setTimeout(() => {
          navigate("/login");
        }, 2000);
      }
    } catch (error: unknown) {
      if (typeof error === "object" && error !== null && "data" in error) {
        const err = error as { data?: Record<string, string[]> };
        toast.error(
          Object.entries(err.data as Record<string, string[]>)
            .map(([_, value]) => value)
            .join(", ") || "Password reset failed: Unknown Error"
        );
      }
      console.error("Failed to send email:", error);
    }
  };

  return (
    <div>
      <Navbar />
      <div className="p-5 h-[81vh] sm:p-14 flex items-start md:items-center justify-center landing-bg bg-cover bg-no-repeat bg-center">
        <div className="w-full md:w-fit flex items-center justify-center flex-col bg-white">
          <div className=" sm:p-10 rounded-2xl sm:border border-[#7E57C233]  w-[100%] sm:w-[80%] md:w-fit flex items-center justify-between gap-20 ">
            <div className="flex flex-col gap-6 items-start justify-start w-[500px]">
              <h2 className="">Reset Password</h2>
              {error && <p className="text-red-500">{error}</p>}
              <form
                className="flex flex-col items-start justify-center gap-5 w-full"
                onSubmit={handleSubmit}
              >
                <div className="flex items-start justify-center flex-col gap-1.5 w-full">
                  <label htmlFor="newPassword1" className="text-[#666666CC]">
                    Enter New Password
                  </label>
                  <input
                    type="password"
                    name="newPassword1"
                    id="newPassword1"
                    value={formData.newPassword1}
                    onChange={handleChange}
                    placeholder="Enter your password"
                    className="h-11 w-full border border-[#66666659] rounded-lg outline-0 px-3"
                    required
                  />
                </div>
                <div className="flex items-start justify-center flex-col gap-1.5 w-full">
                  <label htmlFor="newPassword2" className="text-[#666666CC]">
                    Confirm New Password
                  </label>
                  <input
                    type="password"
                    name="newPassword2"
                    id="newPassword2"
                    value={formData.newPassword2}
                    onChange={handleChange}
                    placeholder="Enter your password again"
                    className="h-11 w-full border border-[#66666659] rounded-lg outline-0 px-3"
                    required
                  />
                </div>
                <Button
                  text={isLoading ? "Resetting..." : "Reset Password"}
                  disabled={isLoading}
                />
              </form>
            </div>
            <img
              src="/assets/Jellosite-Logo-09.jpg"
              alt=""
              className="w-[250px] hidden md:block"
            />
          </div>
          <ul className="text-[#666666] md:w-full hidden sm:flex gap-3.5 sm:w-[80%]  items-center justify-end mt-1 ">
            <Link to="">
              <li>Help</li>
            </Link>
            <Link to="">
              <li>Privacy</li>
            </Link>
            <Link to="">
              <li>Terms</li>
            </Link>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
